import { render } from "./AdminCard.vue?vue&type=template&id=24d5022f&scoped=true"
import script from "./AdminCard.vue?vue&type=script&lang=js"
export * from "./AdminCard.vue?vue&type=script&lang=js"

import "./AdminCard.vue?vue&type=style&index=0&id=24d5022f&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d5022f"]])

export default __exports__